module.exports = __webpack_public_path__ + "static/media/jerry_xu.4812f515.png";